import { NavLink } from 'react-router-dom';
import { useLocale } from '../../application/i18n/LocaleProvider';
import { PRIMARY_NAVIGATION } from '../../app/routes';
import { GardenIcon, HomeIcon, PlantsIcon } from './BrandIcons';

const ICONS = {
    home: HomeIcon,
    plants: PlantsIcon,
    garden: GardenIcon,
};

/**
 * The primary areas (FR-11), always visible, always in the same order.
 *
 * Every href is locale-prefixed, so tapping a tab can never drop the visitor out
 * of their market and language (CON-002).
 */
export default function BottomNavigation() {
    const { localeCode, t } = useLocale();

    return (
        <nav className="tab-bar" aria-label={t('nav.home')}>
            {PRIMARY_NAVIGATION.map(({ key, path, messageKey }) => {
                const NavigationIcon = ICONS[key];

                return (
                    <NavLink
                        key={key}
                        to={`/${localeCode}${path}`}
                        end={path === ''}
                        className="tab-bar__item"
                    >
                        <NavigationIcon className="tab-bar__icon" />
                        <span className="tab-bar__label">{t(messageKey)}</span>
                    </NavLink>
                );
            })}
        </nav>
    );
}
